export const sleep = (ms = 40) => {
  return new Promise(resolve => setTimeout(resolve, ms));
};
